(ns frontend.test.kanban-list.view
  "The test page of the column of a Kanban board. It shows the open column, the
   collapsed column, the column with no button that adds an item, the column that
   a card is dragged over, and a column with a long title. The page does not
   load data. Compare it with the columns of the Dealflow page of the UX mockup."
  (:require
   [reagent.core :as r]
   [ui.components.card.kanban :as card-kanban]
   [ui.components.kanban-list.view :as kanban-list]))

(def sample-cards
  [{:title  "Neagen"
    :status :won
    :rows   [{:key "ticket" :label "Ticket size" :value "5 000 000 AED"}
             {:key "next" :label "Next step" :value "Finalize SPA"}]
    :footer [{:text "20.3.2026" :title "Updated" :date? true}]}
   {:title  "Nordwind Holdings"
    :status :on-track
    :rows   [{:key "ticket" :label "Ticket size" :value "12 400 000 EUR"}
             {:key "next" :label "Next step" :value "Pending diligence sign-off"}]
    :footer [{:text "19.3.2026" :title "Updated" :date? true}]}
   {:title  "Meridian Capital"
    :status :lost
    :rows   [{:key "ticket" :label "Ticket size" :value "Blocked"}]
    :footer [{:text "18.3.2026" :title "Updated" :date? true}]}])

(def columns
  [{:id    "lead"
    :title "Lead"
    :count 3
    :add?  true}
   {:id    "qualified"
    :title "Qualified"
    :count 2
    :add?  true}
   {:id    "closed"
    :title "Closed"
    :count 24
    :add?  true}
   {:id    "no-add"
    :title "A column with no button"
    :count 1
    :add?  false}
   {:id    "drop"
    :title "Drop target"
    :count 0
    :add?  true
    :drop? true}
   {:id    "long"
    :title "A column with a very long title that does not fit in the header"
    :count 1048
    :add?  true}])

(defonce state*
  (r/atom {:collapsed #{"closed"}
           :added     []}))

(defn- labels
  [title]
  {:collapse      "Collapse list"
   :expand        "Expand list"
   :add           "Create new"
   :collapse-aria (str "Collapse " title " list")
   :expand-aria   (str "Expand " title " list")
   :add-aria      (str "Add to " title)})

(defn- toggle!
  [id]
  (swap! state* update :collapsed
         (fn [collapsed]
           (if (contains? collapsed id)
             (disj collapsed id)
             (conj collapsed id)))))

(defn- column
  [{:keys [id title count add? drop?]}]
  [:div {:class "tw2-mr-2 tw2-h-full"}
   [kanban-list/view
    {:title              title
     :count              count
     :collapsed?         (contains? (:collapsed @state*) id)
     :drop-target?       (boolean drop?)
     :labels             (labels title)
     :on-toggle-collapse (fn [_]
                           (toggle! id))
     :on-add             (when add?
                           (fn [_]
                             (swap! state* update :added conj title)))}
    [:div {:class "tw2-flex tw2-flex-col tw2-gap-2 tw2-overflow-y-auto"}
     (for [card (if (zero? count)
                  []
                  sample-cards)]
       ^{:key (:title card)}
       [card-kanban/view (assoc card :show-labels? true)])]]])

(defn view
  []
  [:div {:class "tw2 tw2-min-h-screen tw2-bg-white tw2-p-8"}
   [:div {:class "tw2-mx-auto tw2-max-w-[1800px] tw2-space-y-6"}
    [:div {:class "tw2-space-y-2"}
     [:h1 {:class "tw2-text-3xl tw2-font-semibold tw2-text-slate-950"}
      "Kanban Column Playground"]
     [:p {:class "tw2-max-w-3xl tw2-text-sm tw2-text-slate-600"}
      "The column of the UX mockup, with the ZapKit Badge and IconButton and the tooltips of ZapKit. Each column collapses to a strip. The plus button adds a line to the list below."]]
    [:div {:class "tw2-flex tw2-h-[560px] tw2-items-stretch"}
     (for [col columns]
       ^{:key (:id col)}
       [column col])]
    [:div {:class "tw2-text-sm tw2-text-slate-600"}
     "Added: "
     (pr-str (:added @state*))]]])
